import { PropsWithChildren, FC } from 'react'
import { Tag } from 'antd'

interface ThreeDTagPropsType {
    isLocatedInModal?: boolean
}

const ThreeDTag: FC<PropsWithChildren<ThreeDTagPropsType>> = (
    props: ThreeDTagPropsType,
) => {
    const { isLocatedInModal } = props

    return (
        <Tag
            style={{
                height: 'fit-content',
                marginRight: isLocatedInModal ? 0 : '8px',
            }}
            data-test-target="3d-tag"
        >
            3D
        </Tag>
    )
}

export default ThreeDTag
